<template>
  <div class="page-detail">
    <div class="txt">
      （以下简称“我们”或“小铃铛”） 深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，我们承诺，我们将按法律法规的要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息请在使用我们的产品（或服务） 前，仔细阅读并了解本《隐私权政策》。我们希望通过本政策向您说明在使用我们的产品和服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。<br><br>

      本政策适用于广东小铃铛健康科技有限公司产品或服务，如我们关联公司产品或服务中使用了小铃铛信息技术有限公司提供的产品或服务但未设独立法律声明及隐私权政策的，则本政策同样适用于该部分产品或服务。
      您使用或者继续使用我们的产品和服务，都表示您同意我们按照本《隐私权政笛》收集、使用、储存和分享您的如您对本 《隐私权政策》或与本《隐私权政策》相关的事宜有任何问题，请与我们联系。<br><br>

      电子邮件：<br>
      电话：<br>

      本政策将帮助您了解以下内容：<br>
1、我们如何收集和使用您的个人信息<br>
2、我们如何使用cookie和同类技术<br>
3、我们如何共享、转让、公开披露您的个人信息<br>
4、我们如何保护您的个人信息<br>
5、您的权利<br>
6、我们如何处理儿童的个人信息<br>
7、您的个人信息如何在全球范围转移<br>
8、本隐私权政策如何更新<br>
9、如何联系我们<br>
我们如何收集和使用您的个人信息个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<br><br>

1、上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。<br>
2、为您展示和推送医疗相关信息和服务为改善我们的产品和服务、向您提供个性化的互联网电子服务，我们会根据您的浏览及搜索记录、设备信息个人生理健康信息、关注医生、关注医院、所在地区等，提取您的浏览、搜索偏好、行为习惯等特征，基于特殊标签进行人群画像，并推送信息。<br>
3、向您提供互联网电子服务或商品为便于向您交付产品或服务，您需提供收货人姓名、收货人联系电话、收货地址。如果我们委托第三方向您交付时，我们会在征得您同意后将上述信息提供给第三方，如果您拒绝提供此类信息，我们将无法完成相关交付服务。为更好向您提供互联网电子服务，更精准快速的为您挂号，我们可能需要您在在线问诊咨询DWO时提供个人健康生理信息，例如：现疾病、现病史、身体状况、病历、检查报告、用药记录、家族病史、生育信息、以往病史、诊治情况、传染病史、手术以及麻醉记录、医嘱单等，以及体重、身高、肺活量等。如果您不提供以上信息，将会影响您使用部分健康咨询a等服务，但不会影响您进行基本的搜索、浏览。<br>
为更好的好医疗健康服务费等费用，您需要提供银行卡号，该卡预留的手机号码、身份证号码。如您不提供上述信息，将无法正常使用账户相关的支付等功能，但不会影响您进行基本的搜索、浏览。<br>
您可以通过小铃铛小程序为其他人进行RALTD、咨询aat等服务，您需要提供该实际用户的前述个人信息。向我们提供该实际用户的前述个人信息之前，您需确保您已取得其授权同意<br><br>

3、我们如何委托处理、共享、转让、公开披露您的个人信息<br>
（1）委托处理<br>
本业务功能中某些具体的模块或功能由外部供应商提供。例如我们会聘请服务提供商来协助我们提供客户支持。<br>
对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。<br>
（2）共享<br>
我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意。目前，我们会在以下情形中，向您征求您对共享个人信息的授权同意：<br>
a) ……<br>
了解此情形中目前涉及的公司、组织和个人，请点击此处。【提供超链接】<br>
b) ……<br>
了解此情形中目前涉及的公司、组织和个人，请点击此处。【提供超链接】<br>
c) ……<br>
了解此情形中目前涉及的公司、组织和个人，请点击此处。【提供超链接】<br>
我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。<br>
（3）转让<br>
我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：<br>
a) 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；<br>
b) 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。<br>
（4）公开披露<br>
我们仅会在以下情形下，公开披露您的个人信息：<br>
a) 获得您明确同意后；<br>
b) 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
业务功能二的个人信息收集使用规则<br>
略<br><br>

我们如何保护您的个人信息<br>
（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，?-?- <br>
（二）我们已经取得了以下认证：?-?- <br>
（三）我们的数据安全能力：<br>
（四）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。<br>
（五）我们将定期更新并公开安全风险、个人信息安全影响评估等报告的有关内容。您可通过以下方式获得。<br><br>

（三）删除您的个人信息<br>
在以下情形中，您可以向我们提出删除个人信息的请求：<br>
1、如果您不再使用我们的产品或服务，或您注销了账号；<br>
2、如果我们不再为您提供产品或服务。<br>
若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。<br>
当您从我们的服务中删除信息后，对曾经提供的服务信息，我们在备案中看时长予以保留。<br>
（四）改变您授权同意的范围<br>
每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。<br>
您可以通过以下方式自行操作：…… <br>
当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
如果您不想接受我们给您发送的商业广告，您随时可通过以下方式取消：…… <br>
（五）个人信息主体注销账户<br>
您随时可注销此前注册的账户，您可以通过以下方式自行操作：…… <br>
在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。<br>
（六）个人信息主体获取个人信息副本<br>
您有权获取您的个人信息副本，您可以通过以下方式自行操作：…… <br>
在技术可行的前提下，如数据接口已匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。<br>
（七）约束信息系统自动决策<br>
在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。<br>
（八）响应您的上述请求<br>
为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。<br>
我们将在三十天内作出答复。如您不满意，还可以通过以下途径投诉：…… <br>
对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。<br>
在以下情形中，我们将无法响应您的请求：<br>
1、与个人信息控制者履行法律法规规定的义务相关的；<br>
2、与国家安全、国防安全直接相关的；<br>
3、与公共安全、公共卫生、重大公共利益直接相关的；<br>
4、与刑事侦查、起诉、审判和执行判决等直接相关的；<br>
5、个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；<br>
6、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br>
7、响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；<br>
涉及商业秘密的。<br><br>

我们如何处理儿童的个人信息<br>
我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的个人信息主体账户。<br>
对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。<br>
尽管当地法律和习俗对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。<br>
如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。<br><br>

本政策如何更新<br>
我们的个人信息保护政策可能变更。<br>
未经您明确同意，我们不会削减您按照本个人信息保护政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。
对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明个人信息保护政策的具体变更内容）。<br>
本政策所指的重大变更包括但不限于：<br>
1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br>
2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；<br>
3、个人信息共享、转让或公开披露的主要对象发生变化；<br>
4、您参与个人信息处理方面的权利及其行使方式发生重大变化；<br>
5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<br>
6、个人信息安全影响评估报告表明存在高风险时。<br>
我们还会将本政策的旧版本存档，供您查阅。<br>
术限制和其他不可控因素，我们不能完全保证信息的绝对安全。在以下情况下，我们对信息安全问题免责：<br><br>

• 不可抗力：因自然灾害、政府行为、网络攻击、战争等不可抗力因素导致的信息泄露、丢失或损坏，我们不承担责任。<br><br>

• 用户自身行为：如果您因自身原因（如泄露密码、与他人共享账号等）导致信息安全问题，我们不承担责任。<br><br>

• 第三方原因：由于第三方服务提供商（如云计算服务提供商、支付平台等）的原因导致信息安全问题，我们在合理范围内不承担责任。<br><br>

信息共享<br><br>

我们不会将您的个人信息出售或出租给第三方。但在某些情况下，如为了提供必要的服务、遵守法律法规要求等，我们可能会与第三方共享您的信息。对于第三方在使用您的信息过程中出现的问题，我们在合理范围内免责。<br><br>

免责声明<br><br>

本小程序提供的服务和信息是“按现状”和“可得到”的状态提供，我们不做任何形式的明示或默示的保证，包括但不限于对服务的适用性、完整性、准确性、及时性等方面的保证。在任何情况下，我们对因使用或无法使用本小程序而产生的任何直接、间接、偶然、特殊或后果性的损害（包括但不限于数据丢失、利润损失、业务中断等），无论基于何种原因，均不承担责任，即使我们已被告知可能发生此类损害。<br><br>

条款变更<br><br>

我们有权根据业务发展和法律法规要求对本隐私条款进行修改和更新。修改后的条款将在小程序上公布，您继续使用小程序即表示您接受修改后的条款。<br>
如何联系我们<br>
如果您对本个人信息保护政策有任何疑问、意见或建议，通过以下方式与我们联系：…… <br>
我们设立了个人信息保护专职部门（或个人信息保护专员），您可以通过以下方式与其联系：…… <br>
一般情况下，我们将在三十天内回复。<br>
如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：…… <br><br>

其他条款<br><br>

1. 协议的完整性：本协议构成您与小程序运营方之间关于使用本小程序的完整协议，取代之前所有关于本小程序的口头或书面协议。<br><br>

2. 条款的可分割性：如果本协议的任何条款被认定为无效或不可执行，不影响其他条款的效力和可执行性，其他条款应继续有效并执行。<br><br>

3. 争议解决：若您与小程序运营方之间因本协议引起争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权将争议提交至有管辖权的人民法院诉讼解决。<br><br>

4. 协议生效：本协议自您首次使用本小程序时生效，除非小程序运营方另行通知，否则本协议将持续有效，直至您停止使用小程序或协议被依法终止。<br><br>


  </div>
  <div class="bottom-wrap flex-rowc">
      <div class="bottom-wrap-return flex-rowc" @click="handleReturn">
        <span class="icon"></span> 返回
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {
    };
  },
  methods: {
    handleReturn() {
      this.$router.back();
    },
  }
};
</script>
<style lang="less" scoped>
.page-detail {
  box-sizing: border-box;
  font-size: 36px;
  background: #fafafa;
  padding: 120px 50px 320px;
  .txt {
    line-height: 46px;
  }

  .bottom-wrap {
    padding: 25px 0 90px;
    box-sizing: border-box;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    .bottom-wrap-return {
      flex-shrink: 0;
      font-size: 30px;
      color: #747474;
      .icon {
        display: inline-block;
        width: 42px;
        height: 42px;
        background: url("../../assets/images/return-icon2.png") no-repeat
          center;
        background-size: cover;
        margin-right: 10px;
      }
    }
    .bottom-wrap-btn {
      width: 280px;
      height: 69px;
      border-radius: 44px;
      border: 2px solid #0041c8;
      box-sizing: border-box;
      margin-left: 50px;
      color: #0041c8;
      font-size: 30px;
      background: #fff;
    }
  }
}
</style>